import { render, staticRenderFns } from "./PageNotAvailable.vue?vue&type=template&id=30a030f8&"
import script from "./PageNotAvailable.vue?vue&type=script&lang=js&"
export * from "./PageNotAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports